<template>
  <div class="transaction-container" :class="{ selected: isSelected && isTransactionEditable }">
    <div @click="canEditCategory && toggleActions()"><transaction-row :transaction="transaction" :can-edit-category="canEditCategory"
                      :category-name="categoryName" :category-id="categoryId" :isSelected="isSelected"/>
    </div>

    <collapse-transition>
      <actions :actions="actions" :category-name="categoryName" v-show="isSelected && isTransactionEditable"/>
    </collapse-transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CollapseTransition from '../../../../../../../../../base-components/CollapseTransition.vue';
import TransactionRow from './TransactionRow.vue';
import Actions from '../../../../../../../../../base-components/Actions.vue';
import Segment from '../../../../../../../../../Segment';
import ChangeTransactionCategoryPopup from '../../../current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategoryPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'Transaction',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    canEditCategory: {
      type: Boolean,
      required: true,
    },
    categoryName: {
      type: String,
      required: false,
    },
    categoryId: {
      type: String,
      default: '',
    },
  },
  components: {
    TransactionRow,
    CollapseTransition,
    Actions,
  },
  computed: {
    ...mapState('cashflowView', ['actionsExpandedFor']),
    isIncome() {
      return this.transaction.isIncome;
    },
    incomeOrExpense() {
      return this.isIncome ? 'הכנסה' : 'הוצאה';
    },
    isExcludedCategory() {
      return this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_INCOME
          || this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_EXPENSE;
    },
    actionsMapping() {
      return {
        editCategory: {
          text: `להעביר את ה${this.incomeOrExpense} למקום אחר `,
          icon: 'edits-move',
          onClick: this.openEditCategory,
        },
        moveExcludedBack: {
          text: 'להעביר בחזרה לתזרים',
          icon: 'edits-exclude',
          onClick: this.openEditCategory,
        },
      };
    },
    actions() {
      return this.isExcludedCategory
        ? [this.actionsMapping.moveExcludedBack] : [this.actionsMapping.editCategory];
    },
    isTransactionEditable() {
      return this.canEditCategory;
    },
    isSelected() {
      return this.actionsExpandedFor === `${this.transaction.transactionId}${this.categoryName}${this.categoryId}`;
    },
  },
  methods: {
    ...mapActions('editTransaction', ['startEditingTransaction']),
    ...mapActions('cashflowView', ['expandActionsOf']),
    toggleActions() {
      if (this.isSelected) {
        this.expandActionsOf(null);
      } else {
        this.expandActionsOf(`${this.transaction.transactionId}${this.categoryName}${this.categoryId}`);
      }
    },
    openEditCategory() {
      Segment.trackUserInteraction('EditTransactionClicked', {
        businessName: this.transaction.businessName,
        transactionId: this.transaction.transactionId,
      });
      this.startEditingTransaction({
        transaction: this.transaction,
        categoryName: this.categoryName,
        categoryId: this.categoryId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
  },
};

</script>

<style scoped lang="scss">
    @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-container {
    transition: background-color 0.3s;
    background-color: $riseup_gray_0;
    &.selected {
      background-color: $riseup_gray_-1;
    }
    border-bottom: 1px solid $riseup_white;
    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }
    &:last-of-type {
      border-bottom: none;
    }
  }

</style>
